import { useRef, useState, useEffect } from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import { motion } from "framer-motion";
import VideoHeader from "../../img/ALCR3.mp4";
import VideoHeaderPhone from "../../img/ALCR2Phone.mp4";

const MotionBox = motion(Box);

export default function Hero() {
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const videoSource = useBreakpointValue({
    base: VideoHeaderPhone, 
    md: VideoHeader,        
  });

  const objectPositionValue = useBreakpointValue({
    base: "center top",
    md: "center center",
  });

  const heroHeight = useBreakpointValue({
    base: "100vh",
    md: "100vh",
  });

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleLoadedData = () => setIsLoaded(true);
      video.addEventListener("loadeddata", handleLoadedData);
      return () => video.removeEventListener("loadeddata", handleLoadedData);
    }
  }, []);

  return (
    <Box
      id="hero"
      position="relative"
      w="100%"
      minH={heroHeight}
      maxH={heroHeight}
      overflow="hidden"
      bg="#000"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <MotionBox
        position="absolute"
        inset="0"
        zIndex={0}
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
      >
        <video
          ref={videoRef}
          src={videoSource}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/img/video-preview.jpg" 
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: objectPositionValue,
            backgroundColor: "#000", 
          }}
        />
      </MotionBox>
    </Box>
  );
}
